import { useAuth } from 'pages/auth/hooks/useAuth'
import { FunctionComponent, useState } from 'react'
import { useLandingPage } from './hooks/useLandingPage'
import { useLocation, useParams } from 'react-router-dom'
import { useEmailConfirmation } from 'pages/settings/hooks/useEmailConfirmation'
import LandingPage from 'pages/auth/LandingPage'

const Home: FunctionComponent = () => {
  const { admin } = useParams<{ admin: string }>()
  const { pathname } = useLocation()
  const { backendUser } = useAuth()
  const [selectedPage, setSelectedPage] = useState(0)

  const {
    success,
    setSuccess,
    errorCount,
    setErrorCount,
    confirmUser,
    timer,
    setTimer,
    errorFlag,
    setErrorFlag,
    errorMessage,
    setErrorMessage,
    getItem,
    clearItem,
    showConfirmEmailModal,
    setShowConfirmEmailModal,
    resendConfirmationCode
  } = useEmailConfirmation()

  const {
    tabIndex,
    setTabIndex,
    title,
    onSubmit,
    roleType: mode,
    username,
    setUsername,
    password,
    setPassword,
    isLocked,
    setIsLocked,
    handleUsernameChange,
    userId
  } = useLandingPage(admin, pathname)

  return (
    <LandingPage
      showConfirmEmailModal={showConfirmEmailModal}
      setShowConfirmEmailModal={setShowConfirmEmailModal}
      selectedPage={selectedPage}
      setSelectedPage={setSelectedPage}
      onLogin={setTabIndex}
      username={username}
      password={password}
      setUsername={setUsername}
      setPassword={setPassword}
      mode={mode}
      setSelectedTab={e => {
        setTabIndex(e)
        setUsername('')
        setPassword('')
        setIsLocked(false)
      }}
      onClose={() => {
        setSelectedPage(0)
      }}
      title={title}
      onConfirm={onSubmit}
      tabIndex={tabIndex}
      success={success}
      setSuccess={setSuccess}
      errorCount={errorCount}
      setErrorCount={setErrorCount}
      confirmEmail={confirmUser}
      timer={timer}
      setTimer={setTimer}
      errorFlag={errorFlag}
      setErrorFlag={setErrorFlag}
      errorMessage={errorMessage}
      setErrorMessage={setErrorMessage}
      getItem={getItem}
      clearItem={clearItem}
      user={backendUser}
      isLocked={isLocked}
      setIsLocked={setIsLocked}
      handleUsernameChange={handleUsernameChange}
      resendConfirmationCode={() => resendConfirmationCode(userId)}
    />
  )
}
export default Home
